import React from "react";
import { ParallaxText } from "./ParallaxSection";
import { StaggeredChildren, StaggeredItem, FadeInUp, ScaleIn } from "./PageTransition";
import { SectionParticles } from "./ParticleSystem";

export default function About({ dark }) {
  return (
    <section id="about" className="relative max-w-4xl mx-auto py-20 px-4 overflow-hidden">
      {/* Background particles */}
      <SectionParticles dark={dark} count={20} className="opacity-30" />
      
      <ParallaxText speed={0.2} className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold text-[#1b1c4e] dark:text-white bg-gradient-to-r from-[#1b1c4e] via-indigo-600 to-indigo-400 dark:from-white dark:via-indigo-400 dark:to-indigo-300 bg-clip-text text-transparent">
          About Tech ADR IT Solutions
        </h2>
      </ParallaxText>
      
      <FadeInUp delay={0.2} className="mb-8">
        <div className="text-[#23244d] dark:text-white text-lg leading-relaxed bg-white/70 dark:bg-[#23244d]/70 rounded-xl shadow-lg p-8 border border-[#e6e9f5] dark:border-[#23244d] backdrop-blur-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
          <p className="mb-4">
            <span className="font-semibold text-indigo-600 dark:text-indigo-400">Tech ADR IT Solutions Pvt. Ltd.</span> is a next-generation digital solutions company based in Maharashtra, India. We empower startups, SMEs, and local businesses to thrive in the digital era through innovative web development, intelligent automation, and creative branding. Our agile team blends technology, design, and strategy to deliver impactful, user-centric solutions that drive growth and elevate brands.
          </p>
          <p>
            With a focus on affordability, speed, and quality, Tech ADR is your trusted partner for transforming ideas into digital reality. Experience seamless collaboration, transparent processes, and ongoing support as we help you unlock new opportunities in a connected world.
          </p>
        </div>
      </FadeInUp>
      
      <div className="grid md:grid-cols-2 gap-8 mb-8">
        <ScaleIn delay={0.3}>
          <div className="rounded-xl bg-white/80 dark:bg-[#23244d]/80 shadow-lg p-6 border border-[#e6e9f5] dark:border-[#23244d] hover:shadow-xl transition-all duration-300 transform hover:scale-105">
            <h3 className="font-semibold text-xl mb-4 text-indigo-600 dark:text-indigo-400">Vision</h3>
            <p className="text-[#23244d] dark:text-white">
              To empower startups, SMEs, and local businesses with affordable and intelligent digital solutions that enhance visibility, productivity, and market reach.
            </p>
          </div>
        </ScaleIn>
        
        <ScaleIn delay={0.4}>
          <div className="rounded-xl bg-white/80 dark:bg-[#23244d]/80 shadow-lg p-6 border border-[#e6e9f5] dark:border-[#23244d] hover:shadow-xl transition-all duration-300 transform hover:scale-105">
            <h3 className="font-semibold text-xl mb-4 text-indigo-600 dark:text-indigo-400">Mission</h3>
            <p className="text-[#23244d] dark:text-white">
              "Get your business online with Tech ADR IT Solutions"—combining creativity, technology, and strategy to deliver real-world digital solutions.
            </p>
          </div>
        </ScaleIn>
      </div>
      
      <FadeInUp delay={0.5}>
        <div className="rounded-xl bg-white/80 dark:bg-[#23244d]/80 shadow-lg p-6 border border-[#e6e9f5] dark:border-[#23244d]">
          <h3 className="font-semibold text-xl mb-4 text-indigo-600 dark:text-indigo-400">Company Strengths</h3>
          <StaggeredChildren staggerDelay={0.1}>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                "Cost-effective packages",
                "One-stop-shop for branding + development + marketing",
                "Quick turnaround time",
                "Local language support",
                "Active post-launch support",
                "Agile development process"
              ].map((strength, index) => (
                <StaggeredItem key={index}>
                  <div className="flex items-center space-x-3 p-3 rounded-lg bg-indigo-50 dark:bg-indigo-900/30 hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors duration-200">
                    <div className="w-2 h-2 bg-indigo-600 dark:bg-indigo-400 rounded-full"></div>
                    <span className="text-[#23244d] dark:text-white">{strength}</span>
                  </div>
                </StaggeredItem>
              ))}
            </div>
          </StaggeredChildren>
        </div>
      </FadeInUp>
    </section>
  );
} 